var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVietnamFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 335,
    viewBox: "0 0 512 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2152_2637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H512V335.127H0V0Z",
    fill: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.999 81.9111L278.186 147.378H349.866L291.839 187.749L314.026 253.216L255.999 212.767L197.973 253.216L220.159 187.749L162.133 147.378H233.813L255.999 81.9111Z",
    fill: "#FFDD00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2152_2637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 335,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVietnamFlag);
export default __webpack_public_path__ + "static/media/vietnam_flag.98107dbe5946d647a51a2dd2a0f35f86.svg";
export { ForwardRef as ReactComponent };